<template>
  <div class="tab-availability">
    <SetupAvailability :bundle="bundle" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import SetupAvailability from '../components/SetupAvailability';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    SetupAvailability,
    UIButton,
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
  },
})
export default class TabAvailabilityRoute extends Vue {
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.top {
  width: 100%;
  margin-bottom: var(--spacingMd);
  text-align: right;
}
</style>
